import React, { useEffect, useState } from 'react';
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl';
import 'draft-js/dist/Draft.css';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import ToggleButton from '@mui/material/ToggleButton';

import { SearchIcon, DeleteOutlineOutlinedIcon, ErrorOutlineIcon } from '../../../constants/images';

import theme from '../../../theme';

import { CheckboxOrangeMain } from '../../customComponent/checkbox';
import { SearchInputOrangeMain } from '../../customComponent/form';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import useUtils from '../../../hook/useUtils';

import CustomConversionPop from './CustomConversionPop';


const GoogleFieldsAllMetric = (props) => {
  const {
    handleModalDetail,
    changeDefinedFields,
    handleDeleteFields,
    reportLanguage,
    currentSheetName,
    currentSheetSelectFields,
    selectedGeneralFields,
    selectedConversionsFields,
    selectedCustomFields,
    handleFormattedMessage,
    filterOptionFields,
    searchKeyword,
    setSearchKeyword,
    mediaMainColor,
    fieldsBlockHeightS,
  } = props;

  const intl = useIntl();
  const checkFieldIsSelected = (currentData, originalData) => {
    return _.findIndex(currentData, ['expression', originalData]) > -1 ? true : false;
  }

  const { locale } = useGlobalStatus();
  const [transformExpressToTw] = useUtils();
  const [showButton, setShowButton] = useState(false);
  // const [showFieldsDetails, setShowFieldsDetails] = useState({});

  // useEffect(() => {
  //   const initFields = initShowFields(filterOptionFields);
  //   setShowFieldsDetails(initFields);
  // }, [])

  // const initShowFields = (filterOptionFields) => {
  //   return filterOptionFields && filterOptionFields.reduce((acc, field) => {
  //     acc[field.category] = true;
  //     return acc;
  //   }, {});
  // }

  // const handleshowfieldsDetails = (item) => {
  //   setShowFieldsDetails(prev => ({ ...prev, [item.category]: !prev[item.category] }))
  // }

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
  };

  const handleTitle = (field) => {
    const allFields = _.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields);

    const transformExpression = transformExpressToTw(field.expression, allFields, 'google', reportLanguage);
    const format = field.format === 'PERCENT' ? '百分比' : field.format === 'DEFAULT' ? '數字' : '$';

    return `${transformExpression} (${format})`;
  }

  const handleFieldFormat = (field) => {
    const format = field.format === 'PERCENT' ? 'percentage'
      : field.format === 'DEFAULT' ? 'number'
        : 'amount'

    return format;
  }

  const handleshowButton = (field, method) => {
    if ((field.type === 'CUSTOM' || field.type === 'FORMAT') && !field.cid) {
      method === 'enter' ? setShowButton(true) : setShowButton(false);
    }
  }

  return (
    <Box
      sx={{
        flex: 1.6,
        borderRight: `1px solid ${theme.palette.grey.w200}`
      }}
    >
      <Box
        sx={{
          padding: '20px 16px 4px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            paddingBottom: '4px',
            borderBottom: `1px solid ${theme.palette.grey.w200}`,
            fontWeight: 400
          }}
        >
          <FormattedMessage id="createData.field.allFields" />
          <Typography
            variant="caption"
            sx={{
              cursor: 'pointer',
              color: mediaMainColor
            }}
            onClick={() => handleModalDetail('create_custom_metric')}
          >
            <FormattedMessage id="createData.button.createCustomMetrics" />
          </Typography>
        </Box>
        {
          currentSheetName === "" ? "" :
            <SearchInputOrangeMain
              id="search"
              placeholder={intl.formatMessage({ id: "createData.field.searchFields" })}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              sx={{
                width: "100%",
                marginTop: "10px",
              }}
              value={searchKeyword}
              onChange={handleSearchInput}
            />
        }
      </Box>
      {
        <Box
          pt={1}
          sx={{
            height: fieldsBlockHeightS,
            overflow: 'auto',
            paddingLeft: '16px',
            paddingRight: '8px',
          }}
        >
          {
            currentSheetName === "" && filterOptionFields.length ?
              (<Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: theme.palette.grey.w300,
                }}
              >
                <ErrorOutlineIcon sx={{ right: '4px' }} />
                <FormattedMessage id="createData.tab.selectTip" />
              </Box>) : ""
          }
          {
            filterOptionFields.map((el, index) => {
              const mainTitle = el.name === '自訂轉換欄' ? el.category : null;
              const formatCategory = (el.category).replace(/\s+/g, "").toLowerCase();
              return (
                <Box key={`${el.category}_${index}`}>
                  {
                    currentSheetName === "" ? "" :
                      el.child.length > 0 &&
                      <>
                        {/* 指標類別 */}
                        <Typography
                          sx={{
                            marginBottom: '8px',
                            padding: '4px 0 4px 8px',
                            backgroundColor: theme.palette.grey.w100,
                            borderRadius: '2px'
                          }}
                          title={mainTitle}
                        // onClick={() => handleshowfieldsDetails(el)}
                        >
                          {el.name === "自訂轉換欄" ? (
                            <FormattedMessage id='google.field.category.conversionActionColumn' />
                          ) : (
                            <FormattedMessage id={`google.field.category.${formatCategory}`} />
                          )}
                        </Typography>

                        {/* 指標 */}
                        {
                          // showFieldsDetails[el.category] &&
                          <Box pl={0.5} pb={1}>
                            {
                              el.child.map((item, index) => {
                                const title = el.category === 'custom' ? handleTitle(item) : null;
                                const format = el.category === 'custom' ? handleFieldFormat(item) : null;
                                return (
                                  <Stack
                                    key={`${item.expression}_${index}`}
                                    variant='between-center'
                                    onMouseEnter={() => handleshowButton(item, 'enter')}
                                    onMouseLeave={() => handleshowButton(item, 'leave')}
                                  >
                                    <>
                                      <FormControlLabel
                                        control={
                                          <CheckboxOrangeMain
                                            size="small"
                                            name={item.expression}
                                            sx={{
                                              paddingTop: 0,
                                              paddingBottom: '2px',
                                            }}
                                            checked={checkFieldIsSelected(currentSheetSelectFields, item.expression)}
                                            onChange={(e) => changeDefinedFields(e, item)}
                                          // disabled={item.expression === 'metrics.impressions' || item.expression === 'metrics.cost_micros'}
                                          />
                                        }
                                        label={
                                          item.type === 'CUSTOM' ? item.name :
                                            <FormattedMessage id={`google.field.${item.expression}`} />
                                        }
                                        {...(item.type === 'CUSTOM' && {
                                          title: `${title} (${intl.formatMessage({
                                            id: `createFields.label.format.${format}`,
                                          })})`,
                                        })}
                                        title={title}
                                        sx={{
                                          display: 'block',
                                          marginBottom: '8px'
                                        }}
                                      />
                                      {
                                        showButton && (item.type === 'CUSTOM' || item.type === 'FORMAT') && !item.cid &&
                                        <Tooltip title={<FormattedMessage id="createData.button.deleteFieldAllTab" />}>
                                          <DeleteOutlineOutlinedIcon
                                            variant="dark"
                                            sx={{
                                              marginRight: '8px',
                                              marginBottom: '8px',
                                              '&:hover': {
                                                color: mediaMainColor,
                                                cursor: 'pointer'
                                              }
                                            }}
                                            onClick={(e) => handleDeleteFields(e, item, 'deleteField')}
                                          />
                                        </Tooltip>
                                      }
                                    </>
                                  </Stack>
                                )
                              })
                            }
                          </Box>
                        }
                      </>
                  }
                </Box>
              )
            })
          }
        </Box>
      }
    </Box>
  )
}

export default GoogleFieldsAllMetric;